import React from 'react'
import { connect } from 'react-redux'
import { Pane, Button } from 'evergreen-ui'
import { updateCartData } from '../external/actions'
import {
  getFormattedTime,
  checkPastTime,
  checkCartedSlot,
  addToCart,
  getSlotId,
  removeFromCart
} from '../util'

const getFormattedAvailability = (
  availabilityData,
  activityData,
  activityId
) => {
  let activityType =
    availabilityData && availabilityData[0] && availabilityData[0].activityType

  const availability = Object()
  localStorage.setItem('activityType', JSON.stringify(activityType))
  if (availabilityData) {
    availabilityData.forEach(court => {
      court['slots'].forEach(slot => {
        const slotTime = slot['slotTime']

        if (!availability[slotTime]) {
          availability[slotTime] = {
            activityId,
            activityName: activityData['activities'][activityId],
            startTime: slotTime,
            endTime: slot.endTime,
            available: [],
            unavailable: [],
            price: slot.price,
            slotDiscount: slot.slotDiscount,
            slotDuration: court.slotDuration,
            showPaymentLink: slot.showPaymentLink,
            availableSlot: [],
            unavailableSlot: []
          }
        }
        const availableSlot = {
          maxSlot: slot.maxSlotCount,
          availableSlot: slot.available
        }

        const courtItem = {
          courtId: court.courtId,
          courtName: court.courtName,
          courtBrothers: court.courtBrothers,
          bookableCount: slot.available,
          price: slot.price,
          slotDiscount: slot.slotDiscount
        }
        if (slot.available && !slot.blocked) {
          availability[slotTime].available.push(courtItem)
        } else if (slot) {
          availability[slotTime].unavailable.push(courtItem)
        }
        availability[slotTime].availableSlot.push(availableSlot)
      })
    })
  }
  return availability
}

const availableSlots = slot => {
  let available = 0
  available = slot.available.reduce(function (a, b) {
    return a + b.bookableCount
  }, 0)
  return available
}
const unavailableSlots = slot => {
  let unavailable = 0

  // unavailable = slot.available.reduce(function (a, b) {
  //   return a + b.bookableCount
  // }, 0)
  // console.log({ unavailable })
  // let available = slot.availableSlot.reduce(function (a, b) {
  //   return a + b.availableSlot
  // }, 0)

  unavailable = slot.available.reduce(function (a, b) {
    return a + b.bookableCount
  }, 0)
  let available = slot.availableSlot.reduce(function (a, b) {
    return a + b.maxSlot
  }, 0)

  unavailable = available - unavailable
  return unavailable
}

const AvailabilityPane = props => {
  const {
    availabilityData,
    activityData,
    date,
    selectedActivityIndex,
    showUnavailabilityDialog,
    cart,
    bookNow
  } = props
  const activityId = activityData
    ? parseInt(Object.keys(activityData['activities'])[selectedActivityIndex])
    : null
  const formattedAvailability = availabilityData
    ? getFormattedAvailability(availabilityData.data, activityData, activityId)
    : null
  let activityType =
    availabilityData && availabilityData[0] && availabilityData[0].activityType

  return (
    <div className={'availability-pane'}>
      {formattedAvailability &&
        Object.keys(formattedAvailability).map((slot, index) => {
          slot = formattedAvailability[slot]

          const isCarted = cart && checkCartedSlot(date, slot, cart)
          //   const unavailable = slot.unavailable.length
          //   const available = slot.available.length
          const unavailable = unavailableSlots(slot)

          const available = availableSlots(slot)
          const slotId = getSlotId({ date, slot })

          return (
            <Pane key={index} display={'flex'}>
              <Button
                className={!unavailable ? 'unavailable-button' : ''}
                width={'20%'}
                marginRight={5}
                marginLeft={10}
                marginTop={5}
                marginBottom={5}
                appearance={unavailable ? 'primary' : 'default'}
                intent={'danger'}
                justifyContent={'center'}
                onClick={() => {
                  if (unavailable) {
                    showUnavailabilityDialog(true, slot.startTime)
                  }
                }}
              >
                {unavailable}
              </Button>
              <Button
                width={'60%'}
                marginRight={5}
                marginLeft={5}
                marginTop={5}
                marginBottom={5}
                justifyContent={'center'}
                appearance={isCarted ? 'primary' : 'default'}
                onClick={() => {
                  if (available) {
                    if (isCarted) {
                      props.dispatch(updateCartData(removeFromCart(slotId)))
                    } else if (!checkPastTime(`${date} ${slot.startTime}`)) {
                      props.dispatch(
                        updateCartData(addToCart({ date, slot, slotId }))
                      )
                    }
                  }
                }}
              >
                {`${getFormattedTime(slot.startTime)} - ${getFormattedTime(
                  slot.endTime
                )}`}
              </Button>
              <Button
                width={'20%'}
                marginRight={10}
                marginLeft={5}
                marginTop={5}
                marginBottom={5}
                appearance={
                  checkPastTime(`${date} ${slot.startTime}`) || available
                    ? 'primary'
                    : 'default'
                }
                intent={available ? 'success' : 'none'}
                justifyContent={'center'}
                disabled={checkPastTime(`${date} ${slot.startTime}`)}
                onClick={() => {
                  if (available) {
                    bookNow(date, slot, slotId)
                  }
                }}
              >
                {available}
              </Button>
            </Pane>
          )
        })}
    </div>
  )
}

const mapStateToProps = ({ availabilityData, activityData, cart }) => ({
  availabilityData,
  activityData,
  cart
})

export default connect(mapStateToProps)(AvailabilityPane)
